import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminPartnersService } from "@/services/admin-partners-service";
import {
  AdminPartnerProviderConfiguration,
  SaveAdminPartnerProviderRequest,
} from "@/types/admin-partner-provider";

export const partnerProviderKeys = {
  all: ["partnerProviders"] as const,
  lists: () => [...partnerProviderKeys.all, "list"] as const,
};

export const usePartnerProviders = () => {
  return useQuery<AdminPartnerProviderConfiguration[]>({
    queryKey: partnerProviderKeys.lists(),
    queryFn: () => adminPartnersService.listProviders(),
    staleTime: 5 * 60 * 1000,
  });
};

export const useSavePartnerProvider = () => {
  const queryClient = useQueryClient();

  return useMutation<
    AdminPartnerProviderConfiguration,
    unknown,
    SaveAdminPartnerProviderRequest
  >({
    mutationFn: async ({ provider, enabled, data }) => {
      const savedProvider = await adminPartnersService.upsertProvider(
        provider,
        data,
      );

      if (savedProvider.enabled !== enabled) {
        if (enabled) {
          await adminPartnersService.enableProvider(provider);
        } else {
          await adminPartnersService.disableProvider(provider);
        }
      }

      return {
        ...savedProvider,
        enabled,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: partnerProviderKeys.lists(),
      });
    },
  });
};
